/* eslint-disable camelcase */
import common_en from './en/common.json';
import errors_en from './en/errors.json';

// eslint-disable-next-line
export default {
  en: {
    common: common_en,
    errors: errors_en,
  },
};
